import { render, staticRenderFns } from "./newguest.vue?vue&type=template&id=cb869058&scoped=true"
import script from "./newguest.vue?vue&type=script&lang=js"
export * from "./newguest.vue?vue&type=script&lang=js"
import style0 from "./newguest.vue?vue&type=style&index=0&id=cb869058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb869058",
  null
  
)

export default component.exports